'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function styles(invalid) {
  return {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    borderColor: '#cccccc',
    backgroundColor: invalid ? 'pink' : 'white',
    fontFamily: 'Menlo, Monaco, Consolas, "Lucida Console", monospace'
  };
}

function stringifyFromUntrustedProp(obj) {
  try {
    return JSON.stringify(obj, null, 2);
  } catch (e) {
    return JSON.stringify({
      message: e.message
    }, null, 2);
  }
}

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.InputJson',

  propTypes: {
    value: _propTypes2['default'].any.isRequired,
    onChange: _propTypes2['default'].func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      strValue: stringifyFromUntrustedProp(this.props.value),
      invalid: false
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        strValue: stringifyFromUntrustedProp(nextProps.value),
        invalid: false
      });
    }
  },

  handleChange: function handleChange(event) {
    var strValue = event.target.value;
    var invalid = true;
    var value = undefined;
    try {
      value = JSON.parse(strValue);
      invalid = false;
    } catch (e) {} // eslint-disable-line no-empty
    this.setState({ strValue: strValue, invalid: invalid });
    if (!invalid) {
      this.props.onChange(value);
    }
  },

  render: function render() {
    var _state = this.state;
    var strValue = _state.strValue;
    var invalid = _state.invalid;

    return _react2['default'].createElement('textarea', {
      rows: 4,
      style: styles(invalid),
      value: strValue,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];